import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=e2739acc&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=e2739acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2739acc",
  null
  
)

export default component.exports